import {
  useCallback,
  type Dispatch,
  type SetStateAction,
} from 'react';
import type {
  CmarkdowntablePopoverEntry,
  CmarkdowntablePopoverPosition,
} from './Cmarkdowntable.types';

interface UseCmarkdowntablePopoverCloseInput {
  resetPointerState: () => void;
  resetCopyFeedback: () => void;
  clearManualRect: () => void;
  setActiveRowIndex: Dispatch<SetStateAction<number | null>>;
  setPopoverEntries: Dispatch<SetStateAction<CmarkdowntablePopoverEntry[] | null>>;
  setPopoverIdValue: Dispatch<SetStateAction<string>>;
  setPopoverPosition: Dispatch<SetStateAction<CmarkdowntablePopoverPosition | null>>;
}

export function useCmarkdowntablePopoverClose(
  input: UseCmarkdowntablePopoverCloseInput,
): () => void {
  const {
    resetPointerState,
    resetCopyFeedback,
    clearManualRect,
    setActiveRowIndex,
    setPopoverEntries,
    setPopoverIdValue,
    setPopoverPosition,
  } = input;

  return useCallback((): void => {
    resetPointerState();
    resetCopyFeedback();
    clearManualRect();
    setActiveRowIndex(null);
    setPopoverEntries(null);
    setPopoverIdValue('');
    setPopoverPosition(null);
  }, [
    clearManualRect,
    resetCopyFeedback,
    resetPointerState,
    setActiveRowIndex,
    setPopoverEntries,
    setPopoverIdValue,
    setPopoverPosition,
  ]);
}
